<template>
    <v-container class="container" fluid>
        <v-data-table
            :headers="headers"
            :items="split"
            item-key="ProductID"
            :search="search"
            class="elevation-10 ml-2"
            dense
            loading="dataLoading"
            loading-text="Loading... Please wait"
        >
            <template v-slot:top>
                <v-toolbar dense dark color="secondary">
                    <v-spacer />
                    <v-toolbar-title class="white--text"
                        >Split Type</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-title>
                    <v-text-field
                        v-model="search"
                        label="Search"
                        append-icon="mdi-magnify"
                        dense
                    >
                    </v-text-field>
                    <v-spacer />
                    <v-spacer />
                    <v-btn
                        class="ml-1"
                        fab
                        large
                        color="secondary"
                        icon
                        @click="openNewSplit"
                        exact
                    >
                        <v-icon large>mdi-plus-circle</v-icon>
                    </v-btn>
                </v-card-title>
            </template>
            <template v-slot:item.Active="{ item }">
                <v-switch
                    v-model="item.Billable"
                    class="mr-3"
                    color="secondary"
                    dense
                    style="margin-top: 0px;padding-top: 0px;"
                    hide-details
                    @change="changeState(item)"
                >
                </v-switch>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mx-3" @click="openEditDialog(item)"
                    >mdi-pencil</v-icon
                >
                <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
            </template>
        </v-data-table>
        <v-col cols="auto">
            <v-dialog
                transition="dialog-top-transition"
                v-model="dialog"
                max-width="1000"
            >
                <template v-slot:default="dialog">
                    <v-card>
                        <v-toolbar color="secondary" dark
                            >New Split Type
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="dialog.value = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-container>
                            <splitForm v-if="dialog" :id="Id"></splitForm>
                        </v-container>
                    </v-card>
                </template>
            </v-dialog>
        </v-col>
    </v-container>
</template>

<script>
import axios from 'axios';
import splitForm from './SplitTypeForm';
export default {
    name: 'SplitType',
    components: {
        splitForm
    },
    data: function() {
        return {
            dialog: false,
            dataLoading: true,
            edited: {
                ProductID: 0,
                Product: '',
                MaxCap: ''
            },
            defaultItem: {
                ProductID: 0,
                Product: '',
                MaxCap: ''
            },
            headers: [
                {
                    text: 'ID',
                    value: 'SplitTypeID',
                    width: '8%'
                },
                {
                    text: 'SplitTypeName',
                    value: 'SplitTypeName',
                    width: '40%'
                },
                {
                    text: 'SplitTypeDescription',
                    value: 'SplitTypeDescription',
                    width: '30%'
                },
                {
                    text: 'Billable',
                    value: 'Active',
                    width: '17%'
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    width: '5%'
                }
            ],
            search: '',
            Id: 0,
            ban: false,
            split: []
        };
    },

    computed: {
        formTitle() {
            return this.edited.ProductID === 0 ? 'New Product' : 'Edit Product';
        }
    },

    watch: {
        '$store.state.bannerType': function() {
            if (this.$store.state.bannerType == true) {
                this.loadSplitType();
                this.$store.state.bannerType = false;
            }
        }
    },

    mounted() {
        this.loadSplitType();
    },

    methods: {
        openEditDialog(itm) {
            this.Id = itm.SplitTypeID;
            console.log(this.Id);
            this.dialog = true;
        },
        openNewSplit() {
            this.Id = 0;
            this.dialog = true;
        },
        loadSplitType: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('split-type', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.split = response.data;
                    console.log(this.split);
                    this.dataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },

        changeState: function(item) {
            this.edited = Object.assign({}, item);
            this.$store.state.isLoading = true;
            var str = this.$store;
            var params = {
                Billable: this.edited.Billable
            };
            axios
                .put('split-type/' + this.edited.SplitTypeID, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Split Type status changed.'
                    });
                    this.loadSplitType();
                    this.cancel();
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        
    }
};
</script>
